export const PEDIDO_ORDER_TYPE_STRING = "Order Only";
export const VMI_ORDER_TYPE_STRING = "VMI";

export type installationOrderTypeString =
  | typeof PEDIDO_ORDER_TYPE_STRING
  | typeof VMI_ORDER_TYPE_STRING


export const PEDIDO_ORDER_TYPE = "pedido";
export const VMI_ORDER_TYPE = "vmi";

export type installationOrderType =
  | typeof PEDIDO_ORDER_TYPE
  | typeof VMI_ORDER_TYPE

export const INSTALLATION_ORDER_TYPE_TYPES = [
  PEDIDO_ORDER_TYPE,
  VMI_ORDER_TYPE,
] as const;
export type orderType = typeof INSTALLATION_ORDER_TYPE_TYPES[number];

export const INSTALLATION_ORDER_TYPE_MAP: Record<orderType, installationOrderTypeString> = {
  pedido: "Order Only",
  vmi: "VMI",
};

export type tankOrderType = typeof PEDIDO_ORDER_TYPE | typeof VMI_ORDER_TYPE;
